<ng-container *ngIf="accountDetails$ | async as accountDetails">
  <div class="user-button" [matMenuTriggerFor]="isViewingAsInvestor ? null : userActions">
    <mat-icon color="primary" class="notranslate account-circle">account_circle</mat-icon>
    <span class="lo_sensitive client-name capitalize">{{ accountDetails.firstName }}</span>
    <mat-icon *ngIf="!isViewingAsInvestor" color="primary" class="notranslate arrow-down">keyboard_arrow_down</mat-icon>
  </div>
  <!-- Menu -->
  <mat-menu class="user-button-menu" #userActions="matMenu" yPosition="below" xPosition="before">
    <!-- Menu header -->
    <div *ngIf="accountDetails.firstName" class="menu-header" (click)="$event.stopPropagation()">
      <div class="icon-and-name">
        <mat-icon color="primary" class="notranslate" svgIcon="account_circle_outline"></mat-icon>
        <span class="user-name lo_sensitive">{{ accountDetails.firstName }} {{ accountDetails.lastName }}</span>
      </div>
      <span class="covercy-id"> Your Covercy ID: {{ accountDetails.clientIdentifier }} </span>
    </div>

    <button *ngIf="isClientHasActiveOrders" mat-menu-item [routerLink]="myAccountUrl$ | async" color="primary">
      <mat-icon color="primary" class="notranslate">settings</mat-icon>
      My Account
    </button>

    <button *ngIf="isAgent$ | async" terraCheckPermissions [minimumPermissionLevel]="PermissionLevel.Admin" [noPermissionAction]="NoPermissionAction.Hide"
            mat-menu-item [routerLink]="paths.MANAGE_USERS" color="primary">
      <mat-icon color="primary" class="notranslate">manage_accounts</mat-icon>
      Manage Users
    </button>

    @if((availableInvestingEntities$ | async)?.length){
      <button mat-menu-item  (click)="share()" color="primary">
        <mat-icon color="primary" class="notranslate">group</mat-icon>
        Share
      </button>
      }
    <a mat-menu-item [routerLink]="paths.SUPPORT" color="primary">
      <mat-icon color="primary" class="notranslate">help</mat-icon>
      Contact and Help
    </a>

    <button mat-menu-item [routerLink]="paths.LOGOUT">
      <mat-icon color="primary" class="notranslate">exit_to_app</mat-icon>
      Logout
    </button>
  </mat-menu>
</ng-container>
